/* ============================================================
   CANDYDUO — CLASSIC 2026 · Moteur d'effets (version Classic du
   moteur créé pour le thème Néon, couleurs adaptées à la palette
   pastel existante). Amélioration progressive : sans JS, le site
   reste intact.
   ============================================================ */
(function () {
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- 1. Poussière sucrée (canvas) ---------- */
  function sparkles() {
    if (rm) return;
    var c = document.createElement('canvas');
    c.id = 'cn-sparkles';
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    var W, H, DPR, parts = [], mx = 0.5, my = 0.5;
    var COLORS = ['233,30,140', '124,58,237', '59,130,246', '255,255,255'];
    function size() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = c.width = Math.floor(innerWidth * DPR);
      H = c.height = Math.floor(innerHeight * DPR);
      c.style.width = innerWidth + 'px';
      c.style.height = innerHeight + 'px';
      var n = Math.max(18, Math.min(50, Math.floor(innerWidth / 32)));
      parts = [];
      for (var i = 0; i < n; i++) parts.push(spawn(true));
    }
    function spawn(anyY) {
      return {
        x: Math.random() * W,
        y: anyY ? Math.random() * H : H + 10 * DPR,
        r: (Math.random() * 1.6 + 0.5) * DPR,
        vy: (Math.random() * 0.3 + 0.1) * DPR,
        vx: (Math.random() - 0.5) * 0.12 * DPR,
        col: COLORS[(Math.random() * COLORS.length) | 0],
        tw: Math.random() * Math.PI * 2,
        ts: Math.random() * 0.03 + 0.008,
        depth: Math.random() * 0.8 + 0.2
      };
    }
    var raf;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var ox = (mx - 0.5) * 26 * DPR, oy = (my - 0.5) * 18 * DPR;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.vy; p.x += p.vx; p.tw += p.ts;
        if (p.y < -12 * DPR) parts[i] = p = spawn(false);
        var a = (Math.sin(p.tw) * 0.5 + 0.5) * 0.6 + 0.08;
        ctx.beginPath();
        ctx.arc(p.x + ox * p.depth, p.y + oy * p.depth, p.r, 0, 6.2832);
        ctx.fillStyle = 'rgba(' + p.col + ',' + a.toFixed(3) + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    size();
    addEventListener('resize', size);
    if (fine) addEventListener('pointermove', function (e) { mx = e.clientX / innerWidth; my = e.clientY / innerHeight; }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cancelAnimationFrame(raf); else raf = requestAnimationFrame(tick);
    });
    raf = requestAnimationFrame(tick);
  }

  /* ---------- 2. Reveal au scroll ---------- */
  function reveal() {
    if (rm || !('IntersectionObserver' in window)) return;
    var sel = '.cdc-card, product-card, .product-card, .resource-card, .collection-card, .cn-stat, .cn-reveal-auto, [id^="candyduo-store-reviews"], [id^="cdpb-wrap"]';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('cn-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el, i) {
      el.classList.add('cn-reveal');
      el.style.setProperty('--cn-d', ((i % 6) * 70) + 'ms');
      io.observe(el);
    });
  }

  /* ---------- 3. Tilt 3D des cartes ---------- */
  function tilt() {
    if (rm || !fine) return;
    var els = document.querySelectorAll('.cdc-card, .cn-tilt');
    els.forEach(function (el) {
      el.style.transformStyle = 'preserve-3d';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(800px) rotateX(' + (-py * 6).toFixed(2) + 'deg) rotateY(' + (px * 6).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- 4. Curseur lumineux (doux) ---------- */
  function cursor() {
    if (rm || !fine) return;
    var d = document.createElement('div');
    d.id = 'cn-cursor';
    document.body.appendChild(d);
    var tx = innerWidth / 2, ty = innerHeight / 2, x = tx, y = ty, on = false;
    addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!on) { on = true; d.style.opacity = '1'; }
    }, { passive: true });
    (function loop() {
      x += (tx - x) * 0.12; y += (ty - y) * 0.12;
      d.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- 5. Compteurs animés ---------- */
  function counters() {
    var els = document.querySelectorAll('[data-cn-count]');
    if (!els.length) return;
    function run(el) {
      var raw = el.getAttribute('data-cn-count').replace(',', '.');
      var target = parseFloat(raw);
      if (isNaN(target)) return;
      var dec = raw.indexOf('.') > -1 ? 1 : 0;
      var t0 = null, dur = 1400;
      function step(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        k = 1 - Math.pow(1 - k, 3);
        var v = (target * k).toFixed(dec).replace('.', ',');
        el.textContent = v;
        if (k < 1) requestAnimationFrame(step);
      }
      if (rm) { el.textContent = raw.replace('.', ','); return; }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 6. Ombre header au scroll ---------- */
  function headerShadow() {
    var t;
    addEventListener('scroll', function () {
      if (t) return;
      t = setTimeout(function () {
        t = null;
        if (scrollY > 24) document.body.setAttribute('data-cn-scrolled', '');
        else document.body.removeAttribute('data-cn-scrolled');
      }, 60);
    }, { passive: true });
  }

  /* ---------- 7. Panier : regrouper les bonbons par "Sachet" composé ----------
     Chaque bonbon ajouté via "Compose ton sachet" garde sa propre ligne de
     panier Shopify (prix/inventaire/checkout corrects), mais toutes les
     lignes d'un même clic partagent la propriété visible "Sachet" (ex.
     "Sachet 1", "Sachet 2"...). On insère ici, purement visuellement, une
     ligne d'en-tête groupée "Sachet N — total" au-dessus de chaque groupe,
     dans le tiroir panier comme sur la page panier, sans toucher au
     fonctionnement natif (quantités, suppression, checkout). ---------- */
  function sachetCartGrouping() {
    function groupOnce(root) {
      (root || document).querySelectorAll('.cart-items__table tbody').forEach(function (tbody) {
        tbody.querySelectorAll('.cn-sachet-group-row').forEach(function (r) { r.remove(); });
        var rows = Array.prototype.slice.call(tbody.querySelectorAll(':scope > tr.cart-items__table-row'));
        var groups = [];
        rows.forEach(function (row) {
          var label = null;
          row.querySelectorAll('.cart-items__property').forEach(function (p) {
            var dt = p.querySelector('dt');
            if (dt && dt.textContent.replace(':', '').trim() === 'Sachet') {
              var dd = p.querySelector('dd');
              if (dd) label = dd.textContent.trim();
            }
          });
          var last = groups[groups.length - 1];
          if (last && last.label === label) {
            last.rows.push(row);
          } else {
            groups.push({ label: label, rows: [row] });
          }
        });
        groups.forEach(function (group) {
          if (!group.label) return;
          var total = 0;
          group.rows.forEach(function (row) {
            var priceEl = row.querySelector('.cart-items__price text-component');
            var raw = priceEl ? priceEl.getAttribute('value') : '';
            var num = parseFloat(String(raw).replace(/[^0-9,.-]/g, '').replace(',', '.'));
            if (!isNaN(num)) total += num;
          });
          var tr = document.createElement('tr');
          tr.className = 'cn-sachet-group-row';
          var td = document.createElement('td');
          td.setAttribute('colspan', '4');
          td.className = 'cn-sachet-group-label';
          var totalFormatted = total.toFixed(2).replace('.', ',') + ' €';
          var nameSpan = document.createElement('span');
          nameSpan.className = 'cn-sachet-name';
          nameSpan.textContent = group.label;
          var totalSpan = document.createElement('span');
          totalSpan.className = 'cn-sachet-total';
          totalSpan.textContent = totalFormatted;
          td.appendChild(nameSpan);
          td.appendChild(totalSpan);
          tr.appendChild(td);
          tbody.insertBefore(tr, group.rows[0]);
        });
      });
    }

    var scheduled = false;
    var observer;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      if (observer) observer.disconnect();
      requestAnimationFrame(function () {
        try { groupOnce(document); } catch (e) {}
        scheduled = false;
        if (observer) observer.observe(document.body, { childList: true, subtree: true });
      });
    }

    document.addEventListener('cart:update', schedule);

    if ('MutationObserver' in window) {
      observer = new MutationObserver(function (mutations) {
        function isOurs(n) { return n.nodeType === 1 && n.classList && n.classList.contains('cn-sachet-group-row'); }
        var relevant = mutations.some(function (m) {
          var added = Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !isOurs(n); });
          var removed = Array.prototype.some.call(m.removedNodes, function (n) { return n.nodeType === 1 && !isOurs(n); });
          return added || removed;
        });
        if (relevant) schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    schedule();
  }

  /* ---------- 8. Tiroir hamburger : icônes + libellés raccourcis devant les
     3 liens principaux, pour bien montrer que c'est le menu (mêmes symboles
     que le hero / les cartes catégories : ⚡ compose, 👑 patrons, 🎉 événements).
     Purement visuel côté thème : ne touche pas le menu de navigation réel.
     Robuste aux rendus tardifs du composant tiroir via retries + MutationObserver. ---------- */
  function shortenSachetsMenuLabel() {
    var MAP = [
      { match: 'le-sachet-des-patrons', label: '👑 Sachets préparés' },
      { match: 'fais-ton-sachet', label: '⚡ Compose ton sachet' },
      { match: 'evenements', label: '🎉 Événements' }
    ];
    function relabel() {
      MAP.forEach(function (entry) {
        var sel = '#header-component .menu-drawer a[href*="' + entry.match + '"] .menu-drawer__menu-item-text';
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.textContent.trim() !== entry.label) el.textContent = entry.label;
        });
      });
    }
    relabel();
    setTimeout(relabel, 300);
    setTimeout(relabel, 1000);
    setTimeout(relabel, 2500);
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { relabel(); });
      mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ---------- 9. Panier : barre de progression "livraison gratuite dès 40€"
     (Belgique + France, cf. bandeau du header et politique de livraison).
     Le sous-total est calculé à partir des prix de ligne déjà affichés (même
     lecture que le regroupement Sachet ci-dessus), la barre est insérée juste
     au-dessus du tableau d'articles, tiroir panier comme page panier, et se
     met à jour sur "cart:update" et sur toute mutation du panier. ---------- */
  function shippingProgressBar() {
    var THRESHOLD = 40;
    function formatEUR(n) {
      return n.toFixed(2).replace('.', ',') + ' €';
    }
    function renderOnce(root) {
      (root || document).querySelectorAll('.cart-items__table').forEach(function (table) {
        var total = 0;
        table.querySelectorAll('tr.cart-items__table-row').forEach(function (row) {
          var priceEl = row.querySelector('.cart-items__price text-component');
          var raw = priceEl ? priceEl.getAttribute('value') : '';
          var num = parseFloat(String(raw).replace(/[^0-9,.-]/g, '').replace(',', '.'));
          if (!isNaN(num)) total += num;
        });
        var remaining = Math.max(0, THRESHOLD - total);
        var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
        var reached = remaining <= 0.001;
        var bar = table.previousElementSibling;
        if (!bar || !bar.classList || !bar.classList.contains('cn-ship-bar')) {
          bar = document.createElement('div');
          bar.className = 'cn-ship-bar';
          bar.innerHTML = '<div class="cn-ship-bar__label"></div><div class="cn-ship-bar__track"><div class="cn-ship-bar__fill"></div></div>';
          table.parentNode.insertBefore(bar, table);
        }
        bar.classList.toggle('cn-ship-bar--done', reached);
        bar.querySelector('.cn-ship-bar__label').textContent = reached
          ? '🎉 Livraison gratuite débloquée !'
          : 'Plus que ' + formatEUR(remaining) + ' pour la livraison gratuite 🚚';
        bar.querySelector('.cn-ship-bar__fill').style.width = pct.toFixed(1) + '%';
      });
    }

    var scheduled = false;
    var observer;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      if (observer) observer.disconnect();
      requestAnimationFrame(function () {
        try { renderOnce(document); } catch (e) {}
        scheduled = false;
        if (observer) observer.observe(document.body, { childList: true, subtree: true });
      });
    }

    document.addEventListener('cart:update', schedule);

    if ('MutationObserver' in window) {
      observer = new MutationObserver(function (mutations) {
        function isOurs(n) { return n.nodeType === 1 && n.classList && (n.classList.contains('cn-sachet-group-row') || n.classList.contains('cn-ship-bar')); }
        var relevant = mutations.some(function (m) {
          var added = Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && !isOurs(n); });
          var removed = Array.prototype.some.call(m.removedNodes, function (n) { return n.nodeType === 1 && !isOurs(n); });
          return added || removed;
        });
        if (relevant) schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    schedule();
  }

  function boot() {
    try { sparkles(); } catch (e) {}
    try { reveal(); } catch (e) {}
    try { tilt(); } catch (e) {}
    try { cursor(); } catch (e) {}
    try { counters(); } catch (e) {}
    try { headerShadow(); } catch (e) {}
    try { sachetCartGrouping(); } catch (e) {}
    try { shippingProgressBar(); } catch (e) {}
    try { shortenSachetsMenuLabel(); } catch (e) {}
  }
  document.addEventListener('cart:update', function () { try { shortenSachetsMenuLabel(); } catch (e) {} });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
